import { safeNewsView } from "./collectionInput";

/** Only exact, unfiltered bookmarks map to a native equivalent. Preserve all other filters in the source lens. */
export function newsDestination(view: string, collectionId: string, ws?: string) {
  const safe = safeNewsView(view);
  const native: Record<string, string> = {
    "/atlas": "atlas",
    "/theatre/concepts": "concepts",
    "/causal": "causality",
    "/news/storylines": "storylines",
    "/news/research": "subjects",
  };
  if (safe === "/news") return null;
  if (native[safe])
    return {
      to: `/knowledge/analysis/${native[safe]}`,
      search: { source: "news", collection: collectionId, ws, returnTo: "/knowledge/visuals" },
    };
  return {
    to: `/knowledge/source/${encodeURIComponent(collectionId)}`,
    search: { view: safe, ws },
  };
}

export const SOURCE_SECTIONS = [
  { id: "articles", label: "Source articles", view: "/news", roots: ["news"] },
  {
    id: "concepts",
    label: "Concepts and worlds",
    view: "/theatre/3d",
    roots: ["theatre", "planes", "field", "world", "space", "knowledge", "key", "atlas", "causal"],
  },
  {
    id: "operations",
    label: "Source operations",
    view: "/jobs",
    roots: ["jobs", "ai", "thinkers", "sources", "settings", "flows", "runs"],
  },
  {
    id: "markets",
    label: "Markets and simulations",
    view: "/",
    roots: [
      "",
      "forex",
      "decisions",
      "actions",
      "pending",
      "calibration",
      "patterns",
      "backtest",
      "sandbox",
      "wiki",
      "portfolio",
      "paper",
      "watchlists",
      "desk",
    ],
  },
] as const;

export function sourceSection(view: string) {
  const safe = safeNewsView(view);
  if (safe !== view) return undefined;
  const root = safe.split(/[?#]/)[0]?.split("/")[1] ?? "";
  return SOURCE_SECTIONS.find((section) => (section.roots as readonly string[]).includes(root));
}
